import helpIcon from '/images/help-icon.svg'
import timerIcon from '/images/timer-icon.webp'
import { Portal } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react/box'
import { IconButton } from '@chakra-ui/react/button'
import { Flex } from '@chakra-ui/react/flex'
import { Image } from '@chakra-ui/react/image'
import { Popover } from '@chakra-ui/react/popover'
import { Stack } from '@chakra-ui/react/stack'
import { Text } from '@chakra-ui/react/text'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { esumStore } from '@/pages/Esum/esumStore'

import classes from './styles.module.css'
import { useRemainingsTime } from './useRemainingTime'

import { OfferTooltip } from '../OfferTooltip'

export const TimerBlock = observer(() => {
  const [open, setOpen] = useState(false)

  const activationDate = esumStore.offerData?.progress?.last_activated_dt!
  const serverTime = esumStore.offerData?.server_dt!
  const time = useRemainingsTime(serverTime, activationDate)
  const isExpired = time === 0

  return (
    <Box className={`${classes.container} ${isExpired ? classes.expired : ''}`}>
      <Flex className={classes.row}>
        <Box className={classes.iconWrapper}>
          <Image src={timerIcon} alt="" />
        </Box>

        <Stack className={classes.textStack}>
          <Stack
            className={classes.timeStack}
            role="timer"
            aria-live="polite"
            aria-atomic="true"
          >
            <Text className={classes.time}>
              {isExpired ? '00 минут' : `${Math.min(time, 60)} минут`}
            </Text>
            <Text className={classes.label}>
              {isExpired
                ? 'Проверяем результат'
                : 'Время на выполнение задания'}
            </Text>
          </Stack>
        </Stack>

        <Popover.Root open={open} onOpenChange={(e) => setOpen(e.open)}>
          <Popover.Trigger asChild>
            <IconButton
              aria-label="Подробнее о задании"
              size="xs"
              onClick={() => setOpen((v) => !v)}
              className={classes.infoBtn}
            >
              <Image src={helpIcon} alt="" className={classes.helpIcon} />
            </IconButton>
          </Popover.Trigger>
          <Portal>
            <Popover.Positioner>
              <Popover.Content
                p={0}
                width={320}
                shadow="none"
                className={classes.popoverContent}
              >
                <Popover.Arrow className={classes.popoverArrow}>
                  <Popover.ArrowTip />
                </Popover.Arrow>
                <Popover.Body>
                  <OfferTooltip onClose={() => setOpen(false)} />
                </Popover.Body>
              </Popover.Content>
            </Popover.Positioner>
          </Portal>
        </Popover.Root>
      </Flex>
    </Box>
  )
})
